import { Fragment } from 'react'
import { Link } from '@ds/components'

import styles from './GenreLinks.module.css'

export type TGenreLinkView = {
    /** The genre slug — two subgenres can share a title, so the title is not an identity. */
    id: string
    title: string
    /** A subgenre whose parent is unknown has no page to link to, so it renders as plain text. */
    href?: string
}

type TGenreLinksProps = {
    items: TGenreLinkView[]
}

export const GenreLinks = ({ items }: TGenreLinksProps) => (
    <>
        {items.map((item, index) => (
            <Fragment key={item.id}>
                {item.href ? (
                    <Link variant="primary" href={item.href} className={styles.link}>
                        {item.title}
                    </Link>
                ) : (
                    <span className={styles.plain}>{item.title}</span>
                )}
                {index < items.length - 1 ? ', ' : null}
            </Fragment>
        ))}
    </>
)
